import React, { useState } from 'react';
import { X, ShieldAlert } from 'lucide-react';
import toast from 'react-hot-toast';

const ReportModal = ({ isOpen, onClose, ownerName, onSubmit }) => {
  const [report, setReport] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!report.trim()) {
      toast.error('Please provide details about the suspicious behavior');
      return;
    }
    await onSubmit({ report });
    setReport('');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
              <ShieldAlert className="w-6 h-6 text-red-600" />
            </div>
            <h2 className="text-xl font-bold text-red-600">Report Suspicious Activity</h2>
          </div>

          <p className="text-sm text-gray-600 mb-6">
            If you believe this landlord is fraudulent (e.g., asking for wire transfers before viewing, listing properties they don't own), please report them.
          </p>

          <form onSubmit={handleSubmit}>
            {/* Report Text */}
            <div className="mb-6">
              <div className="relative">
                <textarea
                  value={report}
                  onChange={(e) => setReport(e.target.value)}
                  placeholder="Please provide details about the suspicious behavior..."
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none resize-none h-32"
                  maxLength={500}
                />
                <div className="absolute bottom-3 right-3 flex items-center gap-2">
                  <span className="text-xs text-gray-400">{report.length}/500</span>
                  <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-red-100 hover:bg-red-200 text-red-600 font-semibold py-3 rounded-xl transition-colors"
            >
              Submit Report
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;
